import { z } from 'zod'

const figureSchema = z.object({
  asset: z.string(),
  quantity: z.string()
})

const figuresSchema = z.object({
  description: z.string(),
  assets: z.array(figureSchema)
})

export const seasonConfigSchema = z.object({
  id: z.number(),
  redeem_start_date: z.string(),
  redeem_end_date: z.string(),
  estimated_ship_target: z.string(),
  heroGlam: z.object({
    asset: z.string(),
    title: z.string(),
    description: z.string(),
    width: z.number(),
    height: z.number()
  }),
  stickers: z.array(z.string()),
  figures: figuresSchema
})

export type SeasonConfig = z.infer<typeof seasonConfigSchema>
export type PrizeWallFigure = z.infer<typeof figureSchema>
